import { render } from "./personalneedsComponent.vue?vue&type=template&id=9f0ba96e&scoped=true"
import script from "./personalneedsComponent.vue?vue&type=script&lang=js"
export * from "./personalneedsComponent.vue?vue&type=script&lang=js"

import "./personalneedsComponent.vue?vue&type=style&index=0&id=9f0ba96e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f0ba96e"]])

export default __exports__